import { Sparkles } from "lucide-react";
import CallbackForm from "./CallbackForm";

const HERO_IMG = "/images/hero-fv.png";

export default function HeroLeadFotowoltaika() {
  return (
    <section
      id="top"
      className="relative pt-24 lg:pt-32 pb-12 lg:pb-20 overflow-hidden hero-grid-bg"
      data-testid="hero-section-fv"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-14 items-center">
          {/* Left: copy + form */}
          <div className="lg:col-span-7 heliora-fade-up">
            <div className="inline-flex items-center gap-2 rounded-full bg-brand-surface text-brand-blue px-3 py-1.5 text-xs font-bold uppercase tracking-wider">
              <Sparkles className="h-3.5 w-3.5" />
              Bezpłatna konsultacja
            </div>
            <h1 className="mt-4 font-heading font-extrabold tracking-tight text-brand-ink text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.05]">
              Twoja{" "}
              <span className="relative inline-block">
                <span className="relative z-10">fotowoltaika</span>
                <span className="absolute left-0 right-0 bottom-1 h-3 bg-brand-yellow/70 -z-0 rounded-sm"></span>
              </span>{" "}
              z Heliora.
            </h1>
            <p className="mt-5 text-base sm:text-lg text-brand-muted leading-relaxed max-w-xl">
              Prowadzimy Cię od rozmowy aż do gotowej instalacji.
              Oddzwonimy w <strong className="text-brand-ink">5–10 minut</strong>.
            </p>

            {/* Lead form */}
            <div id="lead-form" className="mt-7 max-w-xl scroll-mt-28" data-testid="hero-lead-form-fv">
              <CallbackForm
                source="Hero"
                ctaLabel="Porozmawiajmy o Twoim domu"
                helperText="Bez spamu · Bez zobowiązań · Bez nacisku"
                inputId="hero-phone"
                testIdPrefix="hero-callback"
              />
              <p
                className="mt-2 text-[13px] text-slate-500 opacity-70"
                data-testid="hero-price-note"
              >
                Typowe instalacje: ok. 20–45 tys. zł brutto
              </p>
            </div>
          </div>

          {/* Right: image with overlay card */}
          <div className="lg:col-span-5 relative heliora-fade-up" style={{ animationDelay: "0.1s" }}>
            <div className="absolute -inset-10 sun-glow pointer-events-none" aria-hidden="true" />
            <div className="relative rounded-3xl overflow-hidden shadow-2xl ring-1 ring-black/5 bg-brand-surface">
              <img
                src={HERO_IMG}
                alt="Dom jednorodzinny z instalacją fotowoltaiczną"
                className="w-full h-[320px] sm:h-[440px] lg:h-[500px] object-cover scale-110"
                loading="eager"
              />
              {/* Subtle bottom gradient for overlay card readability */}
              <div
                aria-hidden="true"
                className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"
              />
              <div
                className="absolute bottom-4 left-4 max-w-[68%] sm:max-w-[260px] bg-white/95 backdrop-blur-md rounded-2xl p-3 sm:p-4 shadow-xl border border-white"
                data-testid="hero-overlay-card-fv"
              >
                <p className="font-heading font-bold text-brand-ink text-sm sm:text-lg leading-snug">
                  Spokojny proces<br />
                  od początku do montażu
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
